export const PERMISSIONS = {
	SUBACCOUNTS_VIEW: 6031,
	SUBACCOUNTS_EDIT: 6032,
	SUBACCOUNTS_CREATE_DELETE: 6033,
	COMMERCIAL_DATA: 6012,
	TECHNICAL_DATA: 6002
};
